import Vue from "vue";
import Vuex from "vuex";
import VuexPersistance from "vuex-persist";

import menu from './modules/menu'
import auth from './modules/authentication'
import projects from './modules/projects'
import timer from './modules/timer'
import misc from './modules/misc'
import dispersion from './modules/dispersion'
import devTools from './modules/devTools'

Vue.use(Vuex)

const vuexlocal = new VuexPersistance({
    storage: window.localStorage,
    modules: ['auth', 'timer', 'misc']
})

export default new Vuex.Store({
    state: {
        loading: false,
        windowWidth: null,
        isDSActive: false,
        isPhonePopupActive: false,
        isBeneficiaryDetailPopupActive: false,
        isBankAccountsPopupActive: false
    },
    getters: {
        getApiGatewayHost() {
            return process.env.VUE_APP_API_GATEWAY;
        }
    },
    mutations: {
        setLoading(state, bool) {
            state.loading = bool
        },
        UPDATE_WINDOW_WIDTH (state, width){
            state.windowWidth = width
        },
        TOGGLE_IS_DETAILED_SIMULATION_POPUP_ACTIVE (state, value) {
            state.isDSActive = value;
        },
        TOGGLE_IS_PHONE_POPUP_ACTIVE (state, value) {
            state.isPhonePopupActive = value;
        },
        TOGGLE_IS_BENEFICIARY_DETAIL_POPUP_ACTIVE (state, value) {
            state.isBeneficiaryDetailPopupActive = value
        },
        TOGGLE_IS_BANK_ACCOUNTS_POPUP_ACTIVE (state, value) {
            state.isBankAccountsPopupActive = value
        },
    },
    modules: {
        menu,
        auth,
        projects,
        timer,
        misc,
        dispersion,
        devTools
    },
    plugins: [vuexlocal.plugin]
})
